import { Typography, Box, colors, BoxProps, Tooltip } from "@mui/material";
import { isEmpty, isString } from "lodash";

export interface IKeyValueText extends BoxProps {
  title: string;
  value: string | React.ReactNode;
  isVertical?: boolean;
  titleStyles?: React.CSSProperties;
  valueStyles?: React.CSSProperties;
  show?: boolean;
}

const KeyValueText = ({
  title,
  value,
  isVertical = false,
  titleStyles,
  valueStyles,
  show = true,
  ...rest
}: IKeyValueText) => {
  const renderItems = (value: string | React.ReactNode) => {
    if (value) {
      if (isString(value)) {
        return (
          <Tooltip title={value} placement="left-start">
            <Typography
              data-testid="value-text-testid"
              sx={{
                // Wraps rather than truncating: on a phone the ellipsis cut
                // off the amount being charged.
                flex: "1 1 auto",
                minWidth: 0,
                overflowWrap: "break-word",
                textAlign: isVertical ? "left" : "right",
                ...valueStyles,
              }}
              color={"#000"}
            >
              {value}
            </Typography>
          </Tooltip>
        );
      }

      return value;
    }
  };

  return (
    <Box
      display={isVertical ? "block" : "flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
      flexWrap={"wrap"}
      columnGap={2}
      data-testid="box-test-id"
      style={{
        display: isEmpty(value) ? "none" : "",
      }}
      {...rest}
    >
      <Typography
        data-testid="key-text-testid"
        sx={{
          fontSize: 16,
          fontWeight: "bold",
          flexShrink: 0,
          ...titleStyles,
        }}
        color={colors.grey[600]}
      >
        {title}:
      </Typography>
      {renderItems(value)}
    </Box>
  );
};

export default KeyValueText;
